import { HttpHandlerFn, HttpInterceptorFn, HttpRequest } from '@angular/common/http';
import { catchError, throwError } from 'rxjs';


export const bearerInterceptor: HttpInterceptorFn = (req: HttpRequest<any>, next: HttpHandlerFn) => {

  const bff = 'bff';
  const token = localStorage.getItem("token");
  const url = (new URL(req.url));
  const pathArray = url.pathname.split('/');

  if (token && pathArray[2] === bff){
      req = req.clone({
      setHeaders: {
        Authorization : `Bearer ${token}`
      }
    });
  }
  return next(req).pipe(
    catchError(
      (err) => {
        return throwError(() => err);
      })
  );
}
